import React from 'react'
import moment from 'moment'

import { Text } from './Text'

const DateText = ({ date, format, ...props }) => {
  format = format || 'DD/MM/YYYY'
  if (!date) return date
  const value = moment(date).format(format)
  return <Text {...props}>{value}</Text>
}

export default DateText
